import React, { useState, useEffect, useRef } from 'react';
import './Textarea.css';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  maxLength?: number;
  showCharCount?: boolean;
}
const Textarea: React.FC<TextareaProps> = ({ 
  error, 
  className = '', 
  maxLength,
  showCharCount = false,
  value,
  onChange,
  disabled,
  ...props 
}) => {
  const [charCount, setCharCount] = useState(0);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  
  useEffect(() => {
    if (value !== undefined) {
      setCharCount(String(value).length);
    }
  }, [value]);

  // Ajustar altura automáticamente cuando está disabled y dentro de un modal
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    
    // Verificar si está dentro de un modal
    const isInModal = textarea.closest('.modal-body') !== null;
    
    if (disabled && isInModal) {
      // Resetear altura para recalcular
      textarea.style.height = 'auto';
      // Ajustar altura al contenido
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [value, disabled]);
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let newValue = e.target.value;
    // Limitar a maxLength si está definido
    if (maxLength && newValue.length > maxLength) {
      newValue = newValue.substring(0, maxLength);
      // Crear un nuevo evento con el valor truncado
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value: newValue }
      } as React.ChangeEvent<HTMLTextAreaElement>;
      setCharCount(newValue.length);
      if (onChange) {
        onChange(syntheticEvent);
      }
      return;
    }
    setCharCount(newValue.length);
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div className="textarea-wrapper">
      <textarea
        ref={textareaRef}
        className={`form-textarea ${error ? 'error' : ''} ${className}`}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
        disabled={disabled}
        {...props}
      />
      {showCharCount && maxLength && (
        <div className="char-count">
          {charCount}/{maxLength}
        </div>
      )}
    </div>
  );
};
export default Textarea;
